import script from "./ATT07_002INS.vue?vue&type=script&setup=true&lang=js"
export * from "./ATT07_002INS.vue?vue&type=script&setup=true&lang=js"

import "./ATT07_002INS.vue?vue&type=style&index=0&id=12ca6f94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ca6f94"]])

export default __exports__